import {
  registerInfoConfigList,
  visitInfoConfigList,
  diagTypeFilter,
  personInfoConfigList,
} from "./static-data.js";
import { getDataValue, optionsLabelGetter } from "@/utils/util.js";
import { getLodop } from "@/plugins/LodopFuncs.js";
import insuReceiptPrint from "@/components/insuReceiptPrint/index.vue"; // 医保收费单打印
import { getFormatDate2, getFormatDate1 } from "@/utils/insurance/index";

export default {
  name: "pay-dialog",
  props: {
    // 弹窗显示
    showCardReading: {
      type: Boolean,
      default: false,
    },
    // 应收金额
    receivable: {
      type: [String, Number],
      default: 0,
    },
    // 订单号
    orderNo: {
      type: [String, Number],
      required: true,
    },

    showSettlementDialog: {
      type: Boolean,
      default: false,
    },
    costType: {
      type: [String, Number],
      // required: true,
    }, // 费用类别: 1(自费); 11(普通门诊)；14(慢特病)；9935(独立门诊部个人帐户支付)

    orderType: {
      type: [String, Number],
      // required: true,
    }, // 订单类型: 1门诊病历；2直接售药
    hiCostTotal: {
      type: [String, Number],
      default: 0,
    }, //医保费用总额
    isCharge: {
      type: Boolean,
      default: false, // 是否收费
    },
    recordVersion: {
      type: [String, Number],
      default: "",
    }, //记录版本号
  },
  data() {
    return {
      outpatientSettlementParam: {
        acctUsedFlag: 1, //个人账户使用标志：0不使用；1使用本人个账；2使用共济人个账
        acct_used_flag: "",
        card_sn: "", //卡识别码
        certno: "", //证件号码
        chrg_bchno: "", //收费批次号
        exp_content: "",
        fulamt_ownpay_amt: "", //全自费金额
        id: 0,
        inscp_scp_amt: "", //符合政策范围金额
        insutype: "", //险种类型
        invono: "", //发票号
        mdtrt_cert_no: "", //就诊凭证编号
        mdtrt_cert_type: "", //就诊凭证类型
        mdtrt_id: "", //就诊ID
        med_type: "", //医疗类别
        medfee_sumamt: "", //医疗费总额
        notHiExpenses: 0, //非医保费用
        orderNo: "", //订单号
        overlmt_selfpay: "", //超限价金额
        preselfpay_amt: "", //先行自付金额
        psn_cert_type: "", //证件类型
        psn_no: "", //人员编号
        psn_setlway: "", //个人结算方式
        pub_hosp_rfom_flag: "", //公立医院改革标志
      },
      cardReadingType: "", // 读卡类型
      isShowMsg: false, //是否显示用户信息
      userInfo: {
        //展示信息
        authNo: "",
        ecIndexNo: "",
        ecOrCode: "",
        ecToken: "",
        gender: "",
        idNo: "",
        email: "",
        insuorg: "",
        nul1userName: "",
      },
      // ==============
      isElectPay: false, // 是否电子凭证支付，而不是读卡
      isSettlementLoading: false, // 结算loading
      isUploadMedicalInfoLoading: false, // 上传诊断信息loading
      preSettlementLoading: false, //预结算loading
      newRecordVersion: "", // 新的记录版本号
      acctUsedFlag: 1, //是否使用账户支付
      payMod: "2", //支付方式
      electronicVoucherData: {}, // 电子凭证数据
      socialSecurityCardData: {}, // 社保卡数据
      idCardData: {}, // 身份证数据
      electronicVoucherForm: {
        mdtrt_cert_no: "", // 诊凭证编号
        psn_cert_type: "", // 人员证件类型
        certno: "", // 证件号码
        psn_name: "", // 姓名
        areaNo: "", // 参保地区域编码
      }, // 电子凭证表单
      socialSecurityCardForm: {
        mdtrt_cert_no: "", // 诊凭证编号
        card_sn: "", // 社保卡号
        certno: "", // 证件号码
        psn_name: "", // 人员姓名
        areaNo: "", // 参保地区域编码
      }, // 社保卡表单
      patientInfoParams: {}, // 读卡获取人员信息参数
      idCardForm: {}, // 身份证表单
      patientInfo: {}, // 患者信息
      settlementInfo: {
        outpatientReg: {},
        preSettlementVO: {},
        outpatientVisitsCompVO: {},
        otpFeeDetailedList: [],
      }, // 结算信息
      personInfo: {
        insutype: "",
      }, // 人员信息
      registerInfoConfigList, // 门诊挂号信息
      visitInfoConfigList, // 门诊就诊信息
      personInfoConfigList, // 人员信息
      form: {
        debtorsName: "",
        debtorsPhone: "", //欠款人电话
        cashAmt: 0, //现金
        actualAmt: 0, //实收总额，以下十二项相加应该为此字段值
        debtAmt: 0, //欠款金额
        alipayAmt: 0, //支付宝支付金额
        wechatAmt: 0, //微信支付金额
        posAmt: 0, //刷卡支付金额
        remainingAmt: 0, //余额支付金额
        otherAmt: 0, //其他支付金额
        medicalInsurance: 0, //医保支付金额
        commercialInsurance: 0, //商保支付金额
        wechatAppsAmt: 0, //微信小程序
        wechatPayAmt: 0, //微信当面付
        id: "", //订单id
        medicalIndividual: 0, //医保(个账)
        medicalMutualAid: 0, //医保(共济)
        notHiExpenses: 0, //非医保费用
      },
      visitInfoForm: {
        diseaseType: 11, // 病种编码
        diag_type: "1", // 诊断类别
      }, // 门诊就诊信息
      visitInfoRules: {
        diag_code: [
          { required: true, message: "请选择诊断信息", trigger: "change" },
        ],
      }, // 门诊就诊信息校验规则
      medTypeOptions: [
        { value: "11", label: "普通门诊", code: 197 },
        { value: "9935", label: "独立门诊部个人帐户支付", code: 3401 },
      ], // 病种类别,
      diagTypeOptions: [
        { value: "1", label: "西医诊断" },
        { value: "2", label: "中医诊断" },
      ], //诊断类别 //, { value: '3', label: '中医主证诊断' }
      diseaseList: [], // 病种列表
      diagnosisList: [], // 诊断列表
      setDiagnosisList: [], // 已选诊断列表
      settlementReceipt: {}, // 结算收据
      isHiCustomVisits: true, //是否开启自定义就诊类型
      balance: 0, //获取余额不足是否可以支付
    };
  },
  components: {
    insuReceiptPrint,
  },
  filters: {
    toFixed2: (value) => Number(value).toFixed(2),
  },
  mounted() {
    if (this.countInfo.cityCode == 3401) {
      this.visitInfoForm.diseaseType = 9935;
    } else {
      this.visitInfoForm.diseaseType = 11;
    }
    this.getHiCustomVisits();
    this.getSellPriceUpdate();
  },

  computed: {
    countInfo() {
      return this.$store.state.global.countInfo;
    },
    // 剩余应收金额
    remainingAmt() {
      let {
        preSettlementVO = { fundPaySumamt: 0, acctPay: 0, acctMulaidPay: 0 },
        totalAmount = 0,
      } = JSON.parse(JSON.stringify(this.settlementInfo || {}));
      if (!preSettlementVO.fundPaySumamt) {
        preSettlementVO.fundPaySumamt = 0;
      }
      if (!preSettlementVO.acctPay) {
        preSettlementVO.acctPay = 0;
      }
      if (!preSettlementVO.acctMulaidPay) {
        preSettlementVO.acctMulaidPay = 0;
      }
      if (!totalAmount) {
        totalAmount = 0;
      }
      return (
        totalAmount -
        preSettlementVO.fundPaySumamt -
        preSettlementVO.acctPay -
        preSettlementVO.acctMulaidPay
      ).toFixed(2);
    },
  },
  filters: {
    diagTypeFilter,
  },
  methods: {
    // 检测弹窗，传递参数信息
    async settlementDataProcess(value = {}) {
      console.log(value, "点击了结算");
      this.outpatientSettlementParam.chrg_bchno = value.chrgBchno; //收费批次号
      this.outpatientSettlementParam.certno = value.idCard; //证件号码
      this.outpatientSettlementParam.mdtrt_id = value.mdtrtId; //就诊id
      this.outpatientSettlementParam.insutype = value.insutype; //险种类型
      this.outpatientSettlementParam.orderNo = value.orderNo; //订单号
      this.outpatientSettlementParam.id = value.id; //逻辑id
    },
    // 读卡获取人员信息
    //  选择读卡方式
    cardReadingChange(e) {
      this.getElectronicVoucher("01301"); // 结算 01301
      // try {
      //   if (e == "01") {
      //     this.getElectronicVoucher("01301"); // 结算 01301
      //     if (this.isElectPay) {
      //       this.getElectronicVoucher("01301"); // 结算 01301
      //     } else {
      //       this.getElectronicVoucher("01101"); // 挂号 01101
      //     }
      //   } else if (e == "02") {
      //     this.getIdCode();
      //   } else if (e == "03") {
      //     this.getSbCode();
      //   }
      // } catch (error) {
      //   this.cardReadingType = "";
      // }
    },
    // 读取电子凭证
    async getElectronicVoucher(businessType) {
      const query = {
        data: {
          // businessType:'01101',
          businessType: businessType,
          deviceType: "",
          officeId: "32760",
          officeName: "消化内科",
          operatorId: this.countInfo.doctorId,
          operatorName: this.countInfo.doctorName,
          orgId: this.countInfo.fixMedIns.fixmedinsCode,
        },
        orgId: this.countInfo.fixMedIns.fixmedinsCode,
        transType: "ec.query",
      };
      const params = {
        url: this.countInfo.fixMedIns.tradeUrl,
        data: JSON.stringify(query),
      };
      let res = await this.$api.newInsurance.getElectronicVoucherAPI(params);
      this.outpatientSettlementParam.mdtrt_cert_no = res.data.data.ecToken;
      this.scanStatusInfo = res.data.data;
      this.userInfo = { ...this.userInfo, ...this.scanStatusInfo };

      console.log(res.data.data, "获取用户信息");
      if (res.data.code != 0) {
        this.$message.error("电子凭证获取信息失败");
        this.isShowMsg = false;
      } else {
        this.isShowMsg = true;
      }

      // // 结算
      // const params2 = { extData: JSON.stringify(res) };
      // this.$api.newInsurance.eVoucherPayAPI(params2);
      // if (this.isElectPay) {
      //   // 结算
      //   const params2 = { extData: JSON.stringify(res) };
      //   let res = await this.$api.newInsurance.eVoucherPayAPI(params2);
      // } else {
      //   if (res.data.code == 0) {
      //     // 挂号
      //     this.$message.success("电子凭证获取信息成功");
      //     const { data } = res.data;
      //     this.electronicVoucherForm.mdtrt_cert_no = data.ecToken;
      //     this.electronicVoucherForm.psn_cert_type = data.idType;
      //     this.electronicVoucherForm.certno = data.idNo;
      //     this.electronicVoucherForm.psn_name = data.userName;
      //     this.electronicVoucherForm.areaNo = data.insuOrg;
      //     this.electronicVoucherData = data;
      //     if (this.electronicVoucherForm.mdtrt_cert_no) {
      //       let formData = {
      //         ...this.electronicVoucherForm,
      //         mdtrt_cert_type: this.cardReadingType,
      //         costType: this.costType,
      //         orderNo: this.orderNo,
      //         orderType: this.orderType,
      //       };
      //       await this.getPatientInfoByReadCard(formData);
      //       await this.$nextTick();
      //       this.cardReadingType = "";
      //     }
      //   } else {
      //     this.cardReadingType = "";
      //     this.$message.error(res.data.message || "电子凭证获取信息失败");
      //   }
      // }
    },
    // 结算
    onSubmitSetttlement() {
      let timer = setTimeout(() => {
        this.$api.newInsurance
          .settlementNewAPI({
            ...this.outpatientSettlementParam,
          })
          .then((r) => {
            this.$message.success(res.data.message);
            this.$emit("refresh");
            console.log("结算成功", this.outpatientSettlementParam);
          })
          .catch((err) => {
            this.$message.error("结算失败");
            console.log("结算失败");
          })
          .finally(() => {
            this.isShowMsg = false;
            this.showCardReading = false;
            clearTimeout(timer);
          });
      }, 200);
    },

    // 获取余额不足是否可以支付
    async getSellPriceUpdate() {
      let res = await this.$api.clinicManagement.getHospitalConfig({
        configType: 14,
      });
      this.balance = res.balance || 0;
    },
    async getHiCustomVisits() {
      let res = await this.$api.clinicManagement.getHospitalConfig({
        configType: 13,
      });
      this.isHiCustomVisits = !!res.hiCustomVisits;
    },

    // 读取社保卡号
    async getSbCode() {
      await this.initReadCard();
      let res = await this.$api.newInsurance.getSocialCardNoAPI();
      if (res.data.code == 0) {
        this.$message.success("读取社保卡号成功");
        const { model } = res.data;
        this.socialSecurityCardForm.mdtrt_cert_no = model.cardNo;
        this.socialSecurityCardForm.card_sn = model.identificationNo;
        this.socialSecurityCardForm.certno = model.shbzhmSocialSecurityNo;
        this.socialSecurityCardForm.psn_name = model.name;
        this.socialSecurityCardForm.areaNo = model.areaNo;
        this.socialSecurityCardForm.psn_cert_type = "90";
        this.socialSecurityCardData = model;
        if (this.socialSecurityCardForm.mdtrt_cert_no) {
          let formData = {
            ...this.socialSecurityCardForm,
            mdtrt_cert_type: this.cardReadingType,
            costType: this.costType,
            orderNo: this.orderNo,
            orderType: this.orderType,
          };
          await this.getPatientInfoByReadCard(formData);
          await this.$nextTick();
          this.cardReadingType = "";
        }
      } else {
        this.cardReadingType = "";
        this.$message.error(res.data.message || "读取社保卡号失败");
      }
    },
    async getIdCode() {
      await this.initReadCard();
      let res = await this.$api.newInsurance.getCardNoAPI();
      if (res.data.code == 0) {
        this.readType = 0;
        this.$message.success("读取身份证号成功");
        console.log(res, "获取身份证号");
        const { model } = res.data;
        this.idCardData.mdtrt_cert_no = model.cardNo;
        this.idCardData.certno = model.cardNo;
        this.idCardData.psn_name = model.name;
        this.idCardForm = model;
        if (this.idCardData.mdtrt_cert_no) {
          let formData = {
            ...this.idCardData,
            mdtrt_cert_type: this.cardReadingType,
            psn_cert_type: this.cardReadingType,
            costType: this.costType,
            orderNo: this.orderNo,
            orderType: this.orderType,
          };
          this.getPatientInfoByReadCard(formData);
          await this.$nextTick();
          this.cardReadingType = "";
        }
      } else {
        this.cardReadingType = "";
        this.$message.error(
          res.data.message || "读取身份证号失败，请检查是否放置身份证"
        );
      }
    },
    // 初始化读卡
    async initReadCard() {
      const { fixMedIns } = this.countInfo;
      const params = { url: fixMedIns.apiUrl, User: fixMedIns.useArea };
      await this.$api.newInsurance.initReadCardAPI(params);
    },
    async getPatientInfoByReadCard(obj) {
      this.patientInfoParams = obj;
      let res = await this.$api.newInsurance.getPatientInfoByReadCardAPI({
        ...obj,
        acctUsedFlag: this.acctUsedFlag,
        payMod: this.payMod,
      });
      if (res.data.code == 200) {
        this.$message.success("获取人员信息成功");
        const { data } = res.data;
        this.personInfo = data;
        this.patientInfoParams.readCardId = data.readCardId;
        // this.personInfo.insutype = data.personnelInsuinfoList[0].insutype
        this.$set(
          this.personInfo,
          "insutype",
          data.personnelInsuinfoList[0].insutype
        );
      } else {
        this.$message.error(res.data.message);
      }
    },
    async preSettlement() {
      if (this.personInfo.insutype != 310 && this.countInfo.cityCode === 3401) {
        //合肥只支持职工医保
        this.$message.error(
          optionsLabelGetter(
            this.personInfo.personnelInsuinfoList || [],
            this.personInfo.insutype,
            "insutype",
            "insutypeName"
          ) + "暂不支持"
        );
        return;
      }
      // if (!optionsLabelGetter(this.personInfo.personnelInsuinfoList || [], this.personInfo.insutype, 'insutype', 'balc')) {
      //   return this.$message.error('账户余额不足，请选择其他支付方式')
      // }
      // 余额不足是否可以支付
      if (
        this.hiCostTotal >
        optionsLabelGetter(
          this.personInfo.personnelInsuinfoList || [],
          this.personInfo.insutype,
          "insutype",
          "balc"
        )
      ) {
        let res1 = await this.$confirm(
          "医保账户余额小于医保支付金额，是否继续支付？",
          "友情提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        //  点击确定
        console.log(!this.balance, res1, this.balance);
        if (res1 == "confirm") {
          if (!this.balance) {
            // 余额不足是否可以支付
            return this.$message.error("医保账户余额不足，无法完成支付");
          }
        } else {
          // 点击取消
          return;
        }
      }
      this.preSettlementLoading = true;
      let res = await this.$api.newInsurance.preSettlement({
        ...this.patientInfoParams,
        acctUsedFlag: this.acctUsedFlag,
        payMod: this.payMod,
        insutype: this.personInfo.insutype,
      });
      this.preSettlementLoading = false;
      if (res.data.code == 200) {
        this.$message.success("预结算成功");
        const { data } = res.data;
        this.settlementInfo = data;
        this.$emit("update:showCardReading", false);
        this.preSettlementLoading = false;
        this.$emit("update:showSettlementDialog", true);
        await this.$nextTick();
        let el = document.querySelector('[aria-label="预结算信息"]');
        this.scrollIntoView(el);
      } else {
        this.$message.error(res.data.message);
      }
    },

    async feeCompleted() {
      if (!this.settlementInfo.preSettlementVO) {
        this.$message.error("请先上传结算信息");
        return;
      }
      let {
        acctPay = 0,
        fundPaySumamt = 0,
        acctMulaidPay = 0,
      } = this.settlementInfo.preSettlementVO;
      let total = acctPay + fundPaySumamt + acctMulaidPay;
      console.log("total: ", total);
      if (!total) {
        this.$message.warning(
          "基金余额/个账/共计账户余额为0，无法进行医保结算！"
        );
        return;
      }

      this.isSettlementLoading = true;
      this.form.actualAmt = this.receivable / 1;
      this.form.id = this.id / 1;
      let payModType = ["cashAmt", "wechatAmt", "alipayAmt"][
        this.settlementInfo.outpatientReg.payMod - 1
      ];
      console.log(payModType);
      this.form[payModType] = this.remainingAmt / 1;
      console.log(this.form[payModType]);
      this.form.medicalInsurance =
        this.settlementInfo.preSettlementVO.fundPaySumamt;
      this.form.medicalIndividual = this.settlementInfo.preSettlementVO.acctPay;
      this.form.medicalMutualAid =
        this.settlementInfo.preSettlementVO.acctMulaidPay;
      this.form.recordVersion = this.recordVersion;
      // if (res.data.errorCode == 0) {
      //  3401
      if (
        this.settlementInfo.outpatientReg.mdtrtCertType == "03" &&
        this.countInfo.cityCode == 3401
      ) {
        const total = (
          this.settlementInfo.preSettlementVO.acctPay +
          this.settlementInfo.preSettlementVO.fundPaySumamt
        ).toFixed(2);
        const params = {
          strpCardInfo:
            this.settlementInfo.preSettlementVO.cardSn +
            "|" +
            this.settlementInfo.preSettlementVO.cardNo +
            "|",
          strpPayInfo:
            Number(this.receivable).toFixed(2) +
            "|" +
            total +
            "|" +
            getFormatDate1() +
            "|",
        };
        let res = await this.$api.newInsurance.socialCardTransactions(params);
        if (res.data.code == 0) {
          // 成功的情况继续完成系统的收费操作
          let resolve = await this.$api.feeDispense.changePayWay({
            ...this.form,
            payMod: 7,
          });
          this.newRecordVersion = resolve.recordVersion;
          this.offlinePayCall();
        } else {
          this.$message.error(res.data.message || "社保卡支付失败");
          this.isSettlementLoading = false;
          return;
        }
      } else {
        let res = await this.$api.feeDispense.changePayWay({
          ...this.form,
          payMod: 7,
        });
        this.newRecordVersion = res.recordVersion;
        this.offlinePayCall();
      }
      // }
    },
    async offlinePayCall() {
      try {
        let res = await this.$api.feeDispense.offlinePayCall({
          orderId: this.$route.query.id / 1,
          acct_used_flag: this.acctUsedFlag,
          recordVersion: this.newRecordVersion,
        });
        this.$message.success("恭喜你，支付成功!");
        this.$emit("update:showSettlementDialog", false);
        this.$emit("update:showCardReading", false);
        this.preSettlementLoading = false;
        await this.insuPrint();
        await this.$nextTick();
        this.$router.push({ path: "/fee/waitfee" });
      } catch (error) {
        console.log(error);
      }
    },
    async uploadMedicalInfo() {
      try {
        await this.$refs.visitInfoFormRef.validate();
        this.isUploadMedicalInfoLoading = true;
        let data = JSON.parse(JSON.stringify(this.visitInfoForm));
        data.orderNo = this.orderNo;
        data.id = this.id;
        data.medType = this.settlementInfo.outpatientReg.medType;
        // 通过setDiagnosisList 将data.diag_code中的手写的code改为 ''
        data.diag_code = data.diag_code.map((item) => {
          let obj = this.setDiagnosisList.find((i) => i.name == item);
          if (obj && obj.isHandWrite) {
            return "";
          } else {
            return item;
          }
        });
        if (!data.diag_code.some((item) => item)) {
          this.isUploadMedicalInfoLoading = false;
          return this.$message.error("诊断信息未选择医保诊断类目");
        }
        try {
          let res = await this.$api.newInsurance.uploadMedicalInfo(data);
          console.log(
            "🚀 ~ file: pay-dialog.js:404 ~ uploadMedicalInfo ~ res:",
            res
          );
          if (res.data.code == 200) {
            this.$message.success("上传成功");
            this.settlementInfo = res.data.data;
            await this.$nextTick();
            let el = document.querySelector('[aria-label="预结算信息"]');
            this.scrollIntoView(el);
          } else {
            console.log(res)
            this.$message.error(res.data.message);
            this.isUploadMedicalInfoLoading = false;
          }
        } catch (error) {
          console.log(error)
          this.$message.error(error.message || '请上传病种信息');
          this.isUploadMedicalInfoLoading = false;
        }
        
      } catch (error) {
        this.isUploadMedicalInfoLoading = false;
      }
    },
    // 获取病种类别
    async querySearchDisease(query) {
      if (query != "") {
        return await new Promise((resolve, reject) => {
          setTimeout(() => {
            const params = {
              diseaseType: "11",
              diseaseName: query,
            };
            this.$api.newInsurance.getDiseaseTypeAPI(params).then((res) => {
              if (res.data.code == 200 && res.data.data != null) {
                resolve(res.data.data);
              }
            });
          }, 200);
        });
      } else {
        return [];
      }
    },
    // 病种搜索
    async searchDisease(e) {
      this.diseaseList = await this.querySearchDisease(e);
    },
    // 设置病种下拉框选项值
    diseaseChange(e) {
      this.diseaseList.forEach((item) => {
        if (item.code == e) {
          this.visitInfoForm.dise_name = item.name;
        }
      });
    },
    diagnosisTypeChange() {
      this.visitInfoForm.diag_code = [];
      this.visitInfoForm.diag_name = [];
    },
    // 获取诊断信息
    async querySearchDiagnosis(query) {
      if (query != "") {
        return await new Promise((resolve, reject) => {
          setTimeout(() => {
            const params = {
              diagType: this.visitInfoForm.diag_type,
              diagName: query,
            };
            this.$api.newInsurance.getDiagnosisByTypeAPI(params).then((res) => {
              if (res.data.code == 200 && res.data.data != null) {
                // this[key] = res.data.data
                resolve(res.data.data);
              }
            });
          }, 200);
        });
      } else {
        return [];
      }
    },
    // 诊断搜索
    async diagnosisSearch(e) {
      this.diagnosisList = await this.querySearchDiagnosis(e);
      await this.$nextTick();
      //  合并两个数组 diagnosisList 和  setDiagnosisList 通过code去重
      this.diagnosisList = [
        ...this.diagnosisList,
        ...this.setDiagnosisList,
      ].reduce((prev, cur) => {
        const hasCode = prev.some((item) => item.code === cur.code);
        return hasCode ? prev : [...prev, cur];
      }, []);
    },
    // 设置诊断下拉框选项值
    async setDiagnosisSel(e) {
      let arr = [];
      e.map((item) => {
        // 是否手写 isHandWrite
        let obj = this.diagnosisList.find((i) => i.code == item) || {
          name: item,
          code: item,
          isHandWrite: true,
        };
        if (obj) {
          arr.push(obj);
        }
      });
      if (arr.length > 0) {
        this.setDiagnosisList = arr;
        this.visitInfoForm.diag_name = arr.map((item) => item.name);
      }
      await this.$nextTick();
      this.$refs.diagnosisRef.visible = false;
    },
    // 打印医保收费单
    async insuPrint() {
      let res = await this.$api.newInsurance.getSettlementPrintAPI({
        orderNo: this.orderNo,
      });
      if (res.data.code === 200 && res.data.data) {
        this.settlementReceipt = { ...res.data.data, orderNo: this.orderNo };
        const LODOP = getLodop();
        if (!LODOP) {
          return;
        }
        // 打印事件
        this.$notify({
          title: "友情提示",
          message: "正在打开预览...",
          type: "success",
        });
        this.$refs.insuReceiptPrint.print({ isReview: true });
      } else {
        return this.$notify({
          title: "友情提示",
          message: "未获取结算信息...",
          type: "error",
        });
      }
    },
    // 关闭读卡弹窗
    settlementDialogClose() {
      this.$emit("update:showSettlementDialog", false);
      this.$emit("update:isCharge", false);
    },
    cardReadingClose() {
      this.$emit("update:showCardReading", false);
      this.$emit("update:isCharge", false);
      this.preSettlementLoading = false;
      this.cardReadingType = "";
      this.personInfo = {};
    },
    scrollIntoView(el) {
      // el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' })
      el.scrollIntoView(false);
    },
    getDataValue,
    optionsLabelGetter,
  },
};
